import { create } from 'zustand'

interface Category {
  id: string
  name: string
  description: string
  recommendedNumberOfQuestions: number
}

// Store for generated categories from advanced interview generator
export interface GeneratedCategoriesStore {
  generatedCategories: Category[]
  setGeneratedCategories: (categories: Category[]) => void
  addGeneratedCategory: (category: Category) => void
  clearGeneratedCategories: () => void
}

export const useGeneratedCategoriesStore = create<GeneratedCategoriesStore>((set) => ({
  generatedCategories: [],
  setGeneratedCategories: (categories) => set({ generatedCategories: categories }),
  addGeneratedCategory: (category) => set((state) => ({
    generatedCategories: [...state.generatedCategories, category]
  })),
  clearGeneratedCategories: () => set({ generatedCategories: [] })
}))
